import {
  calcDescuentoFirmaElectronicaV1,
  firmaElectronica,
} from "../../utils/creditUser/calcDctoFirmaElectronica";

/**
 * Calcula el costo de la firma electrónica con descuento.
 * @param {number} amount - Monto solicitado.
 * @param {number} vencimientoEnDias - Plazo en días.
 * @returns {object} { totalFirmaElectronica, dctoFirmaElectronica }
 */
export function calculateFirma(amount, vencimientoEnDias) {
  const dcto = calcDescuentoFirmaElectronicaV1(amount, vencimientoEnDias);
  const total = firmaElectronica - dcto;

  return {
    totalFirmaElectronica: total,
    dctoFirmaElectronica: dcto,
  };
}
